import React, { Component } from 'react';
import Select from 'react-select';
import meta_data from '../data/meta_data.json';
import './ClassRegistrationComponent.css';

class ClassRegistrationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFirstGenerationStudent: false,
            isFirstLanguageEnglish: false, // Fixed the state variable name
            previousGPA: '',
            majorGPA: '',
            selectedClasses: [],
            dangerScore: 0,
        };
    }

    handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        const inputValue = type === 'checkbox' ? checked : value;

        this.setState({
            [name]: inputValue,
        });
    };

    handleClassSelection = (selectedOptions) => {
        const selectedClasses = selectedOptions.map((option) => option.value);

        this.setState({
            selectedClasses,
        });
    };

    calculateDangerScore = () => {
        const classScores = {};

        const previousGPA = parseFloat(this.state.previousGPA);
        const majorGPA = parseFloat(this.state.majorGPA);

        console.log(`Previous GPA: ${previousGPA}`);
        console.log(`Major GPA: ${majorGPA}`);

        if (this.state.isFirstGenerationStudent) {
            for (const course in classScores) {
                classScores[course] = (classScores[course] || 0) + 2;
            }
        }

        if (this.state.isFirstLanguageEnglish) {
            for (const course in classScores) {
                classScores[course] = (classScores[course] || 0) + 5;
            }
        }

        if (!isNaN(previousGPA)) {
            for (const course in classScores) {
                classScores[course] = (classScores[course] || 0) + Math.max(0, (3.0 - previousGPA) * 5);
            }
        }

        if (!isNaN(majorGPA)) {
            for (const course in classScores) {
                classScores[course] = (classScores[course] || 0) + Math.max(0, (2.5 - majorGPA) * 5);
            }
        }

        console.log("Class Scores based on GPA values:", classScores);

        // Search and adjust the cumulative score for the selected classes
        this.state.selectedClasses.forEach((className) => {
            const classIndex = meta_data.findIndex((data) => data.Course === className);
            if (classIndex !== -1) {
                const { "Analysis Sentiment": { Polarity, Subjectivity } } = meta_data[classIndex];
                classScores[className] =
                    (classScores[className] || 0) + Math.abs(Polarity) + (Subjectivity - 0.5);
            }
        });

        console.log("Class Scores with Sentiment-based adjustments:", classScores);

        let cumulativeScore = 0;
        for (const course in classScores) {
            cumulativeScore += classScores[course];
        }
        cumulativeScore /= Object.keys(classScores).length;

        cumulativeScore = Math.min(1, Math.max(-1, cumulativeScore));

        console.log(`Final Cumulative Score: ${cumulativeScore}`);

        this.setState({
            dangerScore: cumulativeScore.toFixed(2)*100,
        });
    };

    calculateDangerColor = (score) => {
        if (score < 0) {
            return 'blue';
        } else {
            const minScore = 0;
            const maxScore = 100;
            const red = Math.round(255 - ((score - minScore) / (maxScore - minScore)) * 255);
            const green = 0;
            const blue = Math.round((score / maxScore) * 255);
            return `rgb(${red}, ${green}, ${blue}`;
        }
    };

    render() {
        const classOptions = meta_data
            .filter((course) => course.Course !== 'None')
            .map((course) => ({
                value: course.Course,
                label: course.Course,
            }));

        return (
            <div className="registration-container">
                <h1 className="registration-title">Class Registration</h1>
                <div className="input-checkbox">
                    <label>
                        First Generation Student:
                        <input
                            type="checkbox"
                            name="isFirstGenerationStudent"
                            checked={this.state.isFirstGenerationStudent}
                            onChange={this.handleInputChange}
                        />
                    </label>
                </div>
                <div className="input-checkbox">
                    <label>
                        First Language Not English:
                        <input
                            type="checkbox"
                            name="isFirstLanguageEnglish"
                            checked={this.state.isFirstLanguageEnglish}
                            onChange={this.handleInputChange}
                        />
                    </label>
                </div>
                <div className="input-text">
                    <label>
                        Previous GPA:
                        <input
                            type="text"
                            name="previousGPA"
                            value={this.state.previousGPA}
                            onChange={this.handleInputChange}
                        />
                    </label>
                </div>
                <div className="input-text">
                    <label>
                        Major GPA:
                        <input
                            type="text"
                            name="majorGPA"
                            value={this.state.majorGPA}
                            onChange={this.handleInputChange}
                        />
                    </label>
                </div>

                <div className="class-selection">
                    <Select
                        isMulti
                        options={classOptions}
                        value={classOptions.filter((option) =>
                            this.state.selectedClasses.includes(option.value)
                        )}
                        onChange={this.handleClassSelection}
                        styles={{
                            control: (provided, state) => ({
                                ...provided,
                                width: 300,
                                backgroundColor: state.isFocused ? '#f0ffff' : 'white',
                                border: '2px solid #1E90FF',
                                borderRadius: '10px',
                                ':hover': {
                                    border: '2px solid #1E90FF',
                                },
                            }),
                            multiValue: (provided) => ({
                                ...provided,
                                backgroundColor: '#6495ED',
                            }),
                            multiValueLabel: (provided) => ({
                                ...provided,
                                color: 'white',
                            }),
                            multiValueRemove: (provided) => ({
                                ...provided,
                                color: 'white',
                            }),
                        }}
                    />
                </div>
                <div className="calculate-button">
                    <button onClick={this.calculateDangerScore}>Calculate Danger Score</button>
                </div>
                <div className="danger-score">
                    <h2>
                        <span className="score-label">Danger Score:</span>{' '}
                        <span style={{ color: this.calculateDangerColor(this.state.dangerScore) }}>
                            {this.state.dangerScore}
                        </span>
                    </h2>
                </div>
            </div>
        );
    }
}

export default ClassRegistrationComponent;
